<div class="container-fluid">
  <app-page-title title="Bagging"></app-page-title>
  <div class="row">
    <div class="col-md-8">
      <div class="card" style="height: 135px;">
        <div class="card-header bg-transparent border-bottom text-uppercase">Manage
        </div>
        <div class="card-body">
          <form [formGroup]="bagForm">
            <div class="row align-items-end">
              <div class="col-md-6">
                <div class="mb-2">
                  <label for="ddlAwb" class="form-label">Available AWB <span class="mandatory">*</span></label>
                  <ng-select #awbRef id="ddlAwb" [items]="availableAwbList" bindLabel="awbnumber" placeholder="Select"
                    [bindValue]="'awbnumber'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlAwb"
                    aria-readonly="true" [groupBy]="'parentawbnumber'" [multiple]="true" [selectableGroup]="true"
                    [closeOnSelect]="false" [selectableGroupAsModel]="false" [hideSelected]="false"
                    [clearSearchOnAdd]="true"
                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                    [ngClass]="{ 'is-invalid':(isFormSubmitted || bagForm.get('ddlAwb').dirty) && bagForm.get('ddlAwb').errors }"
                    (keydown.enter)="useEnterKey && bagForm.get('ddlAwb').valid ? utilities.closeCurrentAndFocusNext(awbRef, managBagBtn) : bagForm.get('ddlAwb').markAsTouched()">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      <div class="ng-value" *ngFor="let item of items | slice:0:5;">
                        <span class="ng-value-label">{{item.awbnumber}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                      </div>
                      <div class="ng-value" *ngIf="items.length > 5">
                        <span class="ng-value-label">{{items.length - 5}} more...</span>
                      </div>
                    </ng-template>

                    <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                      <ng-container>
                        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                          *ngIf="item.parentawbnumber !== ''" [ngModelOptions]="{ standalone : true }" />
                        {{item.parentawbnumber}}
                      </ng-container>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                        [ngModelOptions]="{ standalone : true }" [disabled]="item.disabled" /> {{item.awbnumber}}
                    </ng-template>

                  </ng-select>
                  <div *ngIf="(isFormSubmitted || bagForm.get('ddlAwb').dirty) && bagForm.get('ddlAwb').errors"
                    class="invalid-feedback">
                    <span *ngIf="bagForm.get('ddlAwb').errors.required">You must select at least one AWB to
                      create</span>
                  </div>
                </div>
              </div>

              <!-- Button aligned in the same line -->
              <div class="col-md-4 d-flex mb-2">
                <button #managBagBtn type="button" class="btn btn-sm"
                  [ngClass]="isbagEditMode ? 'btn-info' : 'btn-primary'" (click)="manageBag()"
                  (keydown.enter)="manageBag()">
                  <i [ngClass]="isbagEditMode ? 'mdi mdi-refresh' : 'mdi mdi-plus'"></i>
                  {{ isbagEditMode ? 'Update' : 'Create' }} Bag
                </button>
                <button *ngIf="isbagEditMode" type="button" class="btn btn-secondary btn-sm ms-2"
                  (click)="cancelUpdates()">
                  <i class="mdi mdi-cancel"></i> Cancel
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div class="card">
        <div class="card-header bg-transparent border-bottom text-uppercase">Bag list
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 grid-container">
              <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                [rowData]="bagList" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [pagination]="true"
                (gridReady)="onGridReady($event)">
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div class="card-header bg-transparent border-bottom text-uppercase">EDI No.
        </div>
        <div class="card-body">
          <form [formGroup]="ediForm">
            <div class="row">
              <div class="col-3">
                <div class="mb-2">
                  <label for="prefix" class="form-label">Prefix</label>
                  <input #prefixRef id="prefix" type="text" class="form-control form-control-sm"
                    formControlName="txtPrefix" maxlength="2"
                    [ngClass]="{'is-invalid':(isEDIFormSubmitted || ediForm.get('txtPrefix')?.touched) && ediForm.get('txtPrefix').errors}"
                    (keydown.enter)="useEnterKey && ediForm.get('txtPrefix').valid ? ediNoRef.focus() : ediForm.get('txtPrefix').markAsTouched()">
                  <div
                    *ngIf="(isEDIFormSubmitted || ediForm.get('txtPrefix')?.touched) && ediForm.get('txtPrefix').errors"
                    class="invalid-feedback">
                    <span *ngIf="ediForm.get('txtPrefix').errors.required">Prefix is required</span>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="mb-2">
                  <label for="masterEdiNo" class="form-label">EDI No. Series</label>
                  <input #ediNoRef id="masterEdiNo" type="numeric" class="form-control form-control-sm"
                    formControlName="txtEDINoSeries"
                    [ngClass]="{'is-invalid':(isEDIFormSubmitted || ediForm.get('txtEDINoSeries')?.touched) && ediForm.get('txtEDINoSeries').errors}"
                    (keydown.enter)="useEnterKey && ediForm.get('txtEDINoSeries').valid ? ediNoRef.focus() : ediForm.get('txtEDINoSeries').markAsTouched()">
                  <div
                    *ngIf="(isEDIFormSubmitted || ediForm.get('txtEDINoSeries')?.touched) && ediForm.get('txtEDINoSeries').errors"
                    class="invalid-feedback">
                    <span *ngIf="ediForm.get('txtEDINoSeries').errors.maxlength">Max upto 5 digit only.</span>
                    <span *ngIf="ediForm.get('txtEDINoSeries').errors.required">Series is required</span>
                  </div>
                </div>
              </div>
              <div class="col-3 mt-3">
                <div class="mt-1">
                  <button type="button" class="btn btn-primary save btn-sm w-sm" (click)="saveEdiNo()"
                    (keydown.enter)="saveEdiNo()">Save</button>
                </div>
              </div>

            </div>
            <div class="col-md-12 row">
              <label class="form-label custom-info-label">
                <i class="mdi mdi-alert-circle-outline me-1">Note: Prefix must be of two characters and series of five
                  max.</i>
              </label>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="button-items">
        <a routerLink="/operation/manifests"><button type="button" class="btn btn-secondary w-sm"><i
              class="mdi mdi-arrow-left"></i> Back</button></a>
      </div>
    </div>
  </div>
</div>